// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"f0b185bc","488":"6577a88c","701":"c48d5cdc"}[chunkId] + ".chunk.js";
};